import { InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'
import type { ChatMessage } from '../Chat'
import type { InboundEmailMessage } from '../../mail/InboundEmailMessage'

@InputType()
export class IngestInboundEmailArgs extends ActionArgs {
  // Normalized inbound email built by the inbound router and consumed by the queue processor.
  // Deliberately NOT @Field-decorated — this action runs from the mailgun-inbound queue, never through a
  // GraphQL resolver, so the wrapped message stays a plain transport shape.
  message: InboundEmailMessage
}

export interface IIngestInboundEmail extends IAction<ChatMessage, IngestInboundEmailArgs> {}
